import { createSlice } from "@reduxjs/toolkit";

const initialState={
    filteredValue:"All"
}

const ticketListFilterReducer = createSlice({
    name:"ticketListFilterReducer",
    initialState,
    reducers:{
        addFilteredValue(state,action){
            state.filteredValue = action.payload
        },
        removeFilteredValue(state,action){
            state.filteredValue = action.payload
        }
    }
})

export const {addFilteredValue,removeFilteredValue} = ticketListFilterReducer.actions;
export default ticketListFilterReducer.reducer;